import styled from 'styled-components';

export const OrderInformationSectionWrapper = styled.div<{ isPrint: boolean }>`
  width: 100%;
  border: 1px solid ${props => (props.isPrint ? '#000000' : '#efefef')};
  border-radius: 12px;
`;

export const OrderInformationSectionHeader = styled.div`
  padding: ${p => p.theme.app.padding.horizontal}
    ${p => p.theme.app.padding.horizontal} 0px
    ${p => p.theme.app.padding.horizontal};
`;
